import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import { setupApiSigning } from "@/lib/apiSigning";
import App from "@/App";

setupApiSigning();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
